<template>
  <div>
    <form-field-input
      label="Name: "
      v-model="form.name"
      :validation-errors="validationErrors.name"
    ></form-field-input>

    <form-field-switch
      label="Is Seller Type?"
      v-model="form.is_seller"
    ></form-field-switch>
  </div>
</template>

<script>
import {FormMixin} from "./forms.mixin";
import {ENUMS} from "../services/enums";

export default {
  name: "ContactTypeForm",
  props: ['formData'],
  mixins: [FormMixin],
  data() {
    return {
      form: {},
      validationErrors: {},
      defaultForm: {
        market_id: this.$store.state.market.market.id,
        name: '',
        is_seller: false,
        type: ENUMS.ContactTypeEnum.Other.value
      },
    }
  },
  created() {
    if (this.formData) {
      this.form = this.$utils.clone(this.formData)

      this.form.is_seller = this.formData.type === ENUMS.ContactTypeEnum.Seller.value;
    } else {
      this.form = this.$utils.clone(this.defaultForm);
    }
  },
  methods: {
    update() {
      if (this.form.is_seller) {
        this.form.type = ENUMS.ContactTypeEnum.Seller.value
      } else {
        this.form.type = ENUMS.ContactTypeEnum.Other.value
      }

      return this.$api.contactTypes.update(this.form)
        .then((res) => {
          this.$buefy.toast.open({
            message: 'Contact type was updated',
            type: 'is-success'
          });

          return res;
        });
    },
    create() {
      if (this.form.is_seller) {
        this.form.type = ENUMS.ContactTypeEnum.Seller.value
      } else {
        this.form.type = ENUMS.ContactTypeEnum.Other.value
      }

      return this.$api.contactTypes.create(this.form)
        .then((res) => {
          this.$buefy.toast.open({
            message: 'Contact type was created',
            type: 'is-success'
          });

          return res;
        });
    },
    delete() {
      return this.$api.contactTypes.delete(this.form.id)
        .then((res) => {
          this.$buefy.toast.open({
            message: res.data.message,
            type: 'is-success'
          });

          return res;
        });
    },
  },
}
</script>

<style lang="scss" scoped>

</style>
